<mat-card appearance="outlined" *appRoles="['Configuracion.Ver']">
  <mat-card-header>
    <div class="header-nombre-nuevo">
      <h2>Configuracion</h2>
    </div>
  </mat-card-header>
  <!-- Contenido de filtros -->
  <mat-card-content>
    <div class="row content">
  <div class="col-sm-3">
    <app-nav-panel-configuracion
      (categoriaSeleccionadaEvent)="onCategoriaSeleccionada($event)"
    ></app-nav-panel-configuracion>
  </div>
  <div class="col-sm-9">
    <app-detalle-categoria
      *ngIf="categoriaSeleccionada"
      [categoriaRutaSeleccionada]="categoriaSeleccionada"
    ></app-detalle-categoria>
  </div>
</div>
  </mat-card-content>
</mat-card>


